// Recommendations constants
export const MAX_RECOMMENDED_ITEMS = 7
export const USER_HISTORY_BATCH_SIZE = 2
export const TRENDING_BATCH_SIZE = 2
